import React, { useContext } from "react";
import { Provider } from "react-redux";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import AppContainer from "./container/appContainer";
import Handshake from "./container/handshakeContainer";
import HistoryView from "./container/historyViewContainer";
import UploadView from "./container/uploadViewContainer";
import LoginContainer from "./container/loginContainer";
import uploadPDF from "./container/uploadPDFContainer";
import { store } from "./data/store/configStore";
import BuildStatus from "./components/buildStatus";
import AppComponent from './components/app';
import LoginComponent from './components/login';
import PatientChart, { PatientChartV2 } from './pages/patientChart'; // './components/patientChart';
import PatientHistory from './pages/patientHistory';
import PageNotFound from './pages/pageNotFound';
import ScheduledVisits from './pages/scheduledVisits';
import AsyncOrders from './pages/asyncOrders';
import SearchOrders from './pages/searchOrders';
import Tasks from './pages/tasks';
import ChangePassword from "./pages/changePassword";
import ChangePIN from "./pages/changePIN";
import Profile from "./pages/profile";
import Reports from "./pages/reports";
import RecoverPassword from './components/recoverPassword';
import Snackbar from './components/commonPortal/Snackbar';
import FSPopup from './components/commonPortal/FSPopup';
import { CommonPortalControllerHOC } from './controllers/commonPortal';
import { CommonPortalContext } from './contexts/commonPortal';
import { History } from "./utils/customUtils";
import { FEATURE } from './utils/feature';
import { VISITS_URL_V2 } from './constants/patientChart.constant';
import "./index.css";

const hasFeature = FEATURE();

export const Routes = () => {
  const { ref: { snackbar, fsPopup } } = useContext(CommonPortalContext);

  return (
    <Provider store={store}>
      <Router history={History}>
        <Switch>
          {
            hasFeature.SHOW_LOGIN_PAGE && (
              <Route
                exact
                path="/"
                component={LoginContainer(LoginComponent)}
              />
            )
          }
          <Route
            path='/recover-password'
            component={AppContainer(RecoverPassword)}
          />
          <Route exact path="/handshake" component={Handshake} />
          <Route exact path="/build-status" component={BuildStatus} />
          <Route exact path="/visits" component={AppContainer(AppComponent)} />
          <Route exact path="/history/:orderId/:userId" component={HistoryView} />
          <Route exact path="/viewuploads/:orderId/:patientId/:questionId" component={UploadView} />
          <Route exact path="/viewpdf/:orderId" component={uploadPDF} />
          <Route
            path='/patientchart/:orderId/:patientId'
            component={AppContainer(PatientChart)}
          />
          <Route
            exact
            path="/orderhistory/:orderId/:patientId"
            component={AppContainer(PatientHistory)}
          />
          <Route
            path={VISITS_URL_V2}
            component={AppContainer(ScheduledVisits)}
          />
          <Route
            path='/async-orders'
            component={AppContainer(AsyncOrders)}
          />
          <Route
            path='/search-orders'
            component={AppContainer(SearchOrders)}
          />
          <Route
            path='/tasks'
            component={AppContainer(Tasks)}
          />
          {
            hasFeature.REPORTS && (
              <Route
                path='/reports'
                component={AppContainer(Reports)}
              />
            )
          }
          {
            hasFeature.CHANGE_PASSWORD && (
              <Route
                path='/change-password'
                component={AppContainer(ChangePassword)}
              />
            )
          }
          {
            hasFeature.CHANGE_PIN && (
              <Route
                path='/change-pin'
                component={AppContainer(ChangePIN)}
              />
            )
          }
          {
            hasFeature.PROFILE && (
              <Route
                path='/profile'
                component={AppContainer(Profile)}
              />
            )
          }
          {
            (hasFeature.PATIENT_CHART_V3) && (
              <Route
                path='/patientchart-v3/:orderId/:patientId'
                component={AppContainer(PatientChartV2)}
              />
            )
          }
          <Route
            path='/pnf'
            component={AppContainer(PageNotFound)}
          />
          <Route
            path='*'
            render={() => {
              return (
                <Redirect to={VISITS_URL_V2} />
              )
            }}
          />
  
        </Switch>
      </Router>
  
      <Snackbar ref={snackbar} />
      <FSPopup ref={fsPopup} />
    </Provider>
  );
}

export default CommonPortalControllerHOC(Routes);
